import { render } from "./BackLayout.vue?vue&type=template&id=3031b361"
import script from "./BackLayout.vue?vue&type=script&lang=js"
export * from "./BackLayout.vue?vue&type=script&lang=js"

import exportComponent from "/root/b2b2c-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__